export class StatisticTopContactVehicleDto {

  public vehicleCount!: number;
  public vehicleTypeName: string | undefined;
  public vehicleManufacturerName: string | undefined;
  public vehicleModelName: string | undefined;

  constructor(init?: Partial<StatisticTopContactVehicleDto> | undefined) {
    Object.assign(this, init);
  }
}
